// Class strings only the place components use (the shared ones are in `../components/styles`).

/** A provider id: a long token with no spaces, so it may break anywhere instead of widening the page. */
export const placeId = "text-[13px] break-all [overflow-wrap:anywhere]";

/** The line that names the provider and the staff rule under a set of search results. */
export const attribution =
  "m-0 rounded-sm border border-border bg-muted px-3 py-2 text-sm [overflow-wrap:anywhere]";

/** A link to another site inside a result: a 44 px target (32 px in the compact density). */
export const externalLink =
  "inline-flex min-h-11 items-center text-link underline underline-offset-4 hover:no-underline compact:min-h-8";
